import React from 'react';
import { Link } from 'react-router';


const Credits = () =>
  <div className="setup credits">
    <div className="container">
      <h1>Credits</h1>
      <ul>
        <li>Redux library by <a target="blank" href="https://twitter.com/dan_abramov">Dan Abramov</a> and <a target="blank" href="https://twitter.com/acdlite">Andrew Clark</a></li>
        <li>React-dnd library by Dan Abramov</li>
        <li>React-slingshot boilerplate project by <a target="blank" href="https://twitter.com/housecor">Cory House</a></li>
        <li>Bootstrap Superhero theme by <a target="blank" href="http://thomaspark.co/">Thomas Park</a></li>
        <li>Phage font by <a target="blank" href="http://tugcu.co/">Mehmet Reha Tugcu</a></li>
        <li>Font Awesome by <a target="blank" href="http://fontawesome.io">Dave Gandy</a></li>
        <li>Animate.css by <a target="blank" href="https://daneden.me/">Daniel Eden</a></li>
        <li>Meeple icons and station icon by <a target="blank" href="http://kenney.nl/">kenney.nl</a></li>
        <li>Virus by Monty Martin-Weber from <a target="blank" href="https://thenounproject.com">the Noun Project</a></li>
        <li>Bacteria by Boris Belov from the Noun Project</li>
        <li>Bacteria Icon made by Freepik from <a target="blank" href="http://www.flaticon.com">www.flaticon.com</a></li>
        <li>Bacteria by Maurizio Fusillo from the Noun Project</li>
        <li>Night Icon made by Freepik from www.flaticon.com</li>
        <li>Bacteria Icon made by Freepik from www.flaticon.com</li>
        <li>Building Icon by freepik</li>
        <li>People crowd silhouette by <a target="blank" href="http://all-silhouettes.com/">all-silhouettes.com</a></li>
      </ul>
    </div>
    <footer>
      <Link to="/">Back</Link>
    </footer>
  </div>;

export default Credits;



/** WEBPACK FOOTER **
 ** ./src/components/setup/Credits.js
 **/